// extracted by mini-css-extract-plugin
export default {"intro":"intro_intro__8ooHU","content":"intro_content__7kHEF","baseline":"intro_baseline__cqjPM","bottom":"intro_bottom__QtmBP"};